export default __webpack_public_path__ + "static/media/EmojiGood.96d92d21.svg";